import styled from 'styled-components';

export default styled.div`
  position: absolute;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  padding: 1rem;
  opacity: ${props => (props.visible ? '1' : '0')};
  top: 50%;
  left: 50%;
  margin-top: -1.5rem;
  @media (min-width: 45em) {
    margin-top: auto;
  }
`;
